(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["amandana-language-links"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('amandana-top-localization')) {
    customElements.define('amandana-top-localization', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;

        const mount = () => {
          const group = document.getElementById('header-group');
          if (!group) return;
          const wrapper = this.closest('.amandana-mobile-localization');
          if (wrapper) {
            wrapper.querySelectorAll('style').forEach((style) => document.head.append(style));
          }
          if (this.parentElement !== group) group.prepend(this);
          if (wrapper) wrapper.remove();
        };

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', mount, { once: true, signal });
        } else {
          mount();
          if (signal.aborted) return;
        }

        this.menus = Array.from(this.querySelectorAll('details'));
        this.menus.forEach((menu) => {
          menu.amandanaPanel = menu.querySelector('.amandana-topbar__panel');
          const panel = menu.amandanaPanel;
          if (panel && typeof panel.showPopover === 'function') {
            panel.setAttribute('popover', 'manual');
          }
        });

        document.addEventListener('pointerdown', (event) => {
          const insidePanel = this.menus.some((menu) => menu.amandanaPanel?.contains(event.target));
          if (!this.contains(event.target) && !insidePanel) this.closeMenus();
        }, { signal });

        this.addEventListener('toggle', (event) => {
          const menu = event.target;
          if (menu.tagName !== 'DETAILS' || !this.menus.includes(menu)) return;
          if (menu.open) {
            this.closeMenus(menu);
            this.openPanel(menu);
          } else {
            this.hidePanel(menu);
          }
        }, { capture: true, signal });

        document.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          const menu = this.menus.find((item) => item.open);
          if (!menu) return;
          event.preventDefault();
          this.closeMenus();
          menu.querySelector('summary').focus();
        }, { signal });

        const reposition = () => {
          this.menus.filter((menu) => menu.open).forEach((menu) => this.positionPanel(menu));
        };

        window.addEventListener('resize', reposition, { signal });
        window.visualViewport?.addEventListener('resize', reposition, { signal });

        window.addEventListener('scroll', (event) => {
          if (this.menus.some((menu) => menu.amandanaPanel?.contains(event.target))) return;
          this.closeMenus();
        }, { capture: true, passive: true, signal });
      }

      positionPanel(menu) {
        const panel = menu.amandanaPanel;
        if (!panel) return;
        const anchor = menu.querySelector('summary').getBoundingClientRect();
        const viewport = window.visualViewport;
        const viewportLeft = viewport?.offsetLeft || 0;
        const viewportTop = viewport?.offsetTop || 0;
        const viewportWidth = viewport?.width || document.documentElement.clientWidth;
        const viewportHeight = viewport?.height || window.innerHeight;
        const gutter = 12;

        const width = Math.min(
          menu.classList.contains('amandana-topbar__country') ? 310 : 240,
          viewportWidth - gutter * 2
        );

        const preferredLeft = menu.classList.contains('amandana-topbar__country')
          ? anchor.left
          : anchor.right - width;

        const left = Math.max(
          viewportLeft + gutter,
          Math.min(preferredLeft, viewportLeft + viewportWidth - width - gutter)
        );

        const top = Math.max(
          viewportTop + gutter,
          Math.min(anchor.bottom + 4, viewportTop + viewportHeight - 100)
        );

        const height = Math.min(420, viewportTop + viewportHeight - top - gutter);

        panel.style.setProperty('--amandana-panel-left', `${left}px`);
        panel.style.setProperty('--amandana-panel-top', `${top}px`);
        panel.style.setProperty('--amandana-panel-width', `${width}px`);
        panel.style.setProperty('--amandana-panel-height', `${height}px`);
      }

      openPanel(menu) {
        const panel = menu.amandanaPanel;
        if (!panel) return;
        this.positionPanel(menu);
        panel.hidden = false;
        panel.scrollTop = 0;

        if (typeof panel.showPopover === 'function') {
          if (!panel.matches(':popover-open')) panel.showPopover();
        } else {
          document.body.append(panel);
        }
      }

      hidePanel(menu) {
        const panel = menu.amandanaPanel;
        if (!panel) return;

        if (typeof panel.hidePopover === 'function' && panel.matches(':popover-open')) {
          panel.hidePopover();
        }

        panel.hidden = true;
        if (panel.parentElement !== menu) menu.append(panel);
      }

      closeMenus(except) {
        this.menus?.forEach((menu) => {
          if (menu === except) return;
          menu.open = false;
          this.hidePanel(menu);
        });
      }

      disconnectedCallback() {
        this.closeMenus();
        this.controller?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
